/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleDevice
 */
export interface VehicleDevice {
    /**
     * 
     * @type {string}
     * @memberof VehicleDevice
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof VehicleDevice
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof VehicleDevice
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof VehicleDevice
     */
    vehicleId?: string | null;
    /**
     * This is the mac address of the ELObox, by convention.
     * @type {string}
     * @memberof VehicleDevice
     */
    serialNumber: string;
    /**
     * 
     * @type {Date}
     * @memberof VehicleDevice
     */
    firmwareLastUpdatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof VehicleDevice
     */
    currentVersion: string;
}

/**
 * Check if a given object implements the VehicleDevice interface.
 */
export function instanceOfVehicleDevice(value: object): value is VehicleDevice {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('serialNumber' in value) || value['serialNumber'] === undefined) return false;
    if (!('firmwareLastUpdatedAt' in value) || value['firmwareLastUpdatedAt'] === undefined) return false;
    if (!('currentVersion' in value) || value['currentVersion'] === undefined) return false;
    return true;
}

export function VehicleDeviceFromJSON(json: any): VehicleDevice {
    return VehicleDeviceFromJSONTyped(json, false);
}

export function VehicleDeviceFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleDevice {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'vehicleId': json['vehicleId'] == null ? undefined : json['vehicleId'],
        'serialNumber': json['serialNumber'],
        'firmwareLastUpdatedAt': (new Date(json['firmwareLastUpdatedAt'])),
        'currentVersion': json['currentVersion'],
    };
}

export function VehicleDeviceToJSON(json: any): VehicleDevice {
    return VehicleDeviceToJSONTyped(json, false);
}

export function VehicleDeviceToJSONTyped(value?: VehicleDevice | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'vehicleId': value['vehicleId'],
        'serialNumber': value['serialNumber'],
        'firmwareLastUpdatedAt': value['firmwareLastUpdatedAt'].toISOString(),
        'currentVersion': value['currentVersion'],
    };
}

